<template>
    <div class="space-y-4  mx-auto">
      <div class="space-y-0">
        <div
          v-for="(day, index) in schedule.days"
          :key="index"
          class="flex flex-col sm:flex-row sm:items-center sm:gap-4 border-b p-1 rounded min-h-[45px]"
        >
          <div class="flex items-center gap-2 sm:mb-0">
            <Checkbox v-model="day.enabled" @update:model-value="onDayToggle(day, index)" />
            <span class="w-[150px]">{{ day.label }}</span>
          </div>


          <label v-if="day.enabled" class="flex items-center gap-1 text-sm mr-2">
            <Checkbox v-model="day.is247" />
            24/7
          </label>

          <div
            v-if="day.enabled && !day.is247"
            class="flex items-center gap-2 mt-2 sm:mt-0"
          >
            <Input
              type="time"
              v-model="day.from"
              :ref="el => setInputRef(index, el)"
              :class="getTimeClass(day)"
              class="form-input w-24"
            />
            <span>–</span>
            <Input
              type="time"
              v-model="day.to"
              :class="getTimeClass(day)"
              class="form-input w-24"
            />
          </div>
        </div>
      </div>

      <Button
        variant="outline"
        @click="copyMondayToAll"
      >
        Скопировать <u>Понедельник</u> на все дни
      </Button>
    </div>
  </template>

<script setup>
import { reactive, ref, nextTick, computed, watch } from 'vue'
import { Input } from '@/components/ui/input'
import { Checkbox } from '@/components/ui/checkbox'
import { Button } from '@/components/ui/button'


const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['update:modelValue'])

const dayKeys = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
const dayLabels = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье']

// UI-удобный формат
const schedule = reactive({
  days: dayKeys.map((key, i) => ({
    key,
    label: dayLabels[i],
    enabled: false,
    is247: false,
    from: '',
    to: ''
  }))
})

const inputRefs = ref([])

function setInputRef(index, el) {
    if (el && el.domRef) {
      inputRefs.value[index] = el.domRef
    } else {
      inputRefs.value[index] = null
    }
}

function onDayToggle(day, index) {
  if (day.enabled && !day.from && !day.to) {
    day.from = '09:00'
    day.to = '18:00'
  }

  nextTick(() => {
    if (day.enabled && !day.is247 && inputRefs.value[index]) {
      inputRefs.value[index].focus()
    }
  })
}

function getTimeClass(day) {
    if (!day.enabled || day.is247 || !day.from || !day.to) return ''
    return day.from >= day.to ? 'border-red-500 ring-red-300 ring-1' : ''
}

function copyMondayToAll() {
    const monday = schedule.days[0]
    schedule.days.forEach((day, i) => {
      if (i !== 0) {
        day.enabled = monday.enabled
        day.is247 = monday.is247
        day.from = monday.from
        day.to = monday.to
      }
    })
}

const apiSchedule = computed(() => {
    const result = {}
    for (const day of schedule.days) {
      if (!day.enabled) continue
      if (day.is247) {
        result[day.key] = '24/7'
      } else if (day.from && day.to) {
        result[day.key] = [[day.from, day.to]]
      }
    }
    return result
})

function loadFrom(data) {
    for (const day of schedule.days) {
      const value = data[day.key]
      if (!value) {
        day.enabled = false
        day.is247 = false
        day.from = ''
        day.to = ''
      } else if (value === '24/7') {
        day.enabled = true
        day.is247 = true
        day.from = ''
        day.to = ''
      } else if (Array.isArray(value) && value[0]) {
        day.enabled = true
        day.is247 = false
        day.from = value[0][0]
        day.to = value[0][1]
      }
    }
}

watch(() => props.modelValue, (newVal) => {
  loadFrom(newVal)
}, { deep: true })

watch(apiSchedule, (newVal) => {
  emit('update:modelValue', newVal)
}, { deep: true })

</script>
